import { useDispatch } from 'react-redux';
import { showSnackbar as showSnackbarAction } from '../features/snakbar/snackbarSlice';

export const useSnackbar = () => {
  const dispatch = useDispatch();

  const showSnackbar = (message, severity = 'success', duration = 3000) => {
    dispatch(showSnackbarAction({ message, severity, duration }));
  };

  return { showSnackbar };
};